import BenchlingConfig from 'BenchlingConfig';
import {BenchlingAction} from 'redux-stores/Action';
import {BenchlingState} from 'redux-stores/reduceApp';

import {TenantAdminExtensionsTab, TenantAdminTab} from './TenantAdminConstants';
import {TenantAdminActionType} from './TenantAdminReduxActions';

export const DEFAULT_TAB = TenantAdminTab.ORGANIZATIONS_TAB;
export const DEFAULT_EXTENSIONS_TAB = BenchlingConfig.ENABLE_EXTENSION_TYPE_AGENT_SKILLS
  ? TenantAdminExtensionsTab.AGENT_SKILLS_TAB
  : BenchlingConfig.ENABLE_EXTENSION_TYPE_MODELS
    ? TenantAdminExtensionsTab.MODELS_TAB
    : TenantAdminExtensionsTab.MCP_SERVERS_TAB;

export interface TenantAdminUIState {
  activeTab: TenantAdminTab;
  activeExtensionsTab: TenantAdminExtensionsTab;
}

export class TenantAdminStateSelector {
  tenantState: TenantAdminUIState;

  constructor(state: BenchlingState) {
    this.tenantState = state.ui.tenantAdmin;
  }

  getActiveTab(): TenantAdminTab {
    return this.tenantState.activeTab || DEFAULT_TAB;
  }

  getActiveExtensionsTab(): TenantAdminExtensionsTab {
    return this.tenantState.activeExtensionsTab || DEFAULT_EXTENSIONS_TAB;
  }
}

export const TENANT_UI_INITIAL_STATE: TenantAdminUIState = {
  activeTab: DEFAULT_TAB,
  activeExtensionsTab: DEFAULT_EXTENSIONS_TAB,
};

export default function reduceTenantAdminUI(
  state: TenantAdminUIState = TENANT_UI_INITIAL_STATE,
  action: BenchlingAction
): TenantAdminUIState {
  switch (action.type) {
    case TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_TAB:
      return {...state, activeTab: action.tab};
    case TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_EXTENSIONS_TAB:
      return {...state, activeExtensionsTab: action.tab};
    default:
      return state;
  }
}
